import { TransactionState, TransactionType } from '@/types/crypto';
import i18next from 'i18next';

export const getTransactionTypeDisplayValue = (txType: TransactionType): string =>
  i18next.t('general.transactions.type', { context: txType });

export const getTransactionStateDisplayValue = (txState: TransactionState): string =>
  i18next.t('general.transactions.state', { context: txState });
